import { colors } from "@src/theme"
import styled from "styled-components"

export const StyledUl = styled.ul`
  margin: 0;
  padding-left: 26px;
`

export const VerticalSeparator = styled.div`
  width: 1px;
  height: 86px;
  background-color: ${colors.gray20};
  margin: 25px 0 0;
`

export const CyberConciergeCardStyled = styled.div`
  display: grid;
  grid-template-columns: 1fr 1px 1fr;
  column-gap: 20px;
  > div {
    text-align: center;
  }
`
export const ConciergeNotifications = styled.div`
  cursor: pointer;
`
